import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  swrContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "100%",
    height: "100vh",
    background: theme?.palette?.primaryBG?.[350]
  },
  swrWrapper: {
    background: theme?.palette?.primaryBG?.[350],
    borderRadius: "10px",
    margin: "10px 0",
    height: "40%",
    padding: "20px",
    [theme.breakpoints.up("md")]: {
      width: "60%"
    }
  },
  btnPrimary: {
    background: theme?.palette?.primary2TextColor?.main,
    borderRadius: "10px",
    padding: "6px 20px",
    color: `${theme?.palette?.secondaryText?.[700]} !important`,
    fontSize: "14px",
    fontWeight: "600",
    height: "45px",
    textTransform: "capitalize",
    width: "100%",
    "&:hover": {
      background: theme?.palette?.primary2TextColor?.main
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      width: "100%"
    }
  },
  staticContainer: {
    padding: "0 15px",
    marginTop: "108px",
    [theme.breakpoints.down("md")]: {
      marginTop: "60px"
    },
    marginBottom: "24px"
  },
  casinoWrapper: {
    background: theme?.palette?.primaryBG?.[350],
    borderRadius: "10px",
    margin: "10px 0",
    height: "100%",
    padding: "20px"
  },
  maintenanceImgWrapper: {
    textAlign: "center",
    marginTop: "30px",
    "& img,svg": {
      height: "100px",
      width: "100px",
      [theme.breakpoints.down("md")]: {
        // height: "calc(100vh - 275px)"
      }
    }
  }
}));
